import { createSetupTokenClient, getSetupToken } from "@/domain/_shared/auth/services/auth.service";
import { useQuery } from "@tanstack/react-query";

import { getUserEmailForSetupQueryDocument } from "./two-factor-auth.gql";

interface GetUserEmailForSetupResponse {
  getUserEmailForSetup: string;
}

interface UseGetUserEmailForSetupOptions {
  enabled?: boolean;
}

/**
 * Fetches the current user's email during the forced-2FA setup flow, using the
 * short-lived 2fa_setup token rather than a full access token. Used to label
 * the authenticator-app entry while the user has not yet enrolled.
 */
export const useGetUserEmailForSetup = ({ enabled = true }: UseGetUserEmailForSetupOptions = {}) => {
  const setupToken = getSetupToken();
  return useQuery({
    // Scope the cache to the active setup token so a previous user's email is
    // never served to whoever holds the tab next.
    queryKey: ["getUserEmailForSetup", setupToken],
    enabled: enabled && !!setupToken,
    queryFn: async () => {
      const client = await createSetupTokenClient("getUserEmailForSetup");
      const data = await client.request<GetUserEmailForSetupResponse>(getUserEmailForSetupQueryDocument);
      return data.getUserEmailForSetup;
    },
    retry: false,
  });
};
